<template>
    <div class="wrap">
        <div class="head">
            <banner></banner>
        </div>
        <div class="condition" v-if="sort==1">
            <div class="title">
                <span>姓名</span>
                <span>手机号</span>
                <span>医院</span>
                <span>账号审核结果</span>
                <span>达标学者</span>
                <span>病例审核结果</span>
                <span>视频审核结果</span>
                <span>达标之星</span>
                <span>付款状态</span>
                <span>付款日期</span>
            </div>
            <div class="title item" v-for="(item,index) of data" v-bind:key="index">
                <span>{{item.name}}</span>
                <span>{{tel(item.phone)}}</span>
                <span>{{item.hospital}}</span>
                <span>{{station(item.station)}}</span>
                <span>{{learner(item)}}</span>
                <span>{{caseResult(item)}}</span>
                <span>{{videoResult(item)}}</span>
                <span>{{star(item)}}</span>
                <span>{{payStation(item)}}</span>
                <span>{{item.pay_time}}</span>
            </div>
        </div>
        <div class="condition" v-else>
            <div class="title">
                <span>姓名</span>
                <span>手机号</span>
                <span>医院</span>
                <span>账号审核结果</span>
                <span>已分配病例数</span>
                <span>已审核病例数</span>
                <span>付款状态</span>
                <span>付款日期</span>
            </div>
            <div class="title item" v-for="(item,index) of data" v-bind:key="index">
                <span>{{item.name}}</span>
                <span>{{tel(item.phone)}}</span>
                <span>{{item.hospital}}</span>
                <span>{{station(item.station)}}</span>
                <span>{{item.aNumber}}</span>
                <span>{{item.bNumber}}</span>
                <span>{{judgePayStation(item)}}</span>
                <span>{{item.pay_time}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Indicator } from 'mint-ui';
    import Banner from "@/components/ksd/fragment/Banner";
    import {repSearch,judgeSearch} from "@/assets/js/api";

    export default {
        components:{
            Banner
        },
        data() {
            return {
                type:this.$route.query.type,
                value:this.$route.query.value,
                data:[],
                sort:this.$route.query.sort
            }
        },
        mounted(){
          this.toSearch();
        },
        methods: {

            tel(phone){
                return phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
            },

            station(station){
                return station==1?"已审核":"未审核"
            },

            caseResult(item){
                if(item.case_verify==0){
                    return "待审核"
                }else if(item.case_verify==1){
                    return "审核通过"
                }else{
                    return "未通过"
                }
            },

            videoResult(item){
                if(item.video_verify==0){
                    return "待审核"
                }else if(item.video_verify==1){
                    return "审核通过"
                }else{
                    return "未通过"
                }
            },

            learner(item){
                if(item.score==null) return "未完成"
                return item.score>=75?"已完成":"未完成"
            },

            star(item){
                if((item.phase>=6)&&(item.video_verify==1)&&(item.case_verify==1)){
                    return "已完成"
                }else{
                    return "未完成"
                }
            },

            toSearch(){
                if(this.type==null) return
                if(this.value==null) return
                if(this.sort==1){
                    this.representSearch(this.type,this.value)
                }else{
                    this.judgeSearch(this.type,this.value)
                }
            },

            async representSearch(type,condition){
                Indicator.open({
                    text: '查询中',
                    spinnerType: 'fading-circle'
                });
               const res =  await repSearch({type,condition})
                console.log(res)
                this.data = res.data
                Indicator.close();
            },

            async judgeSearch(type,condition){
                Indicator.open({
                    text: '查询中',
                    spinnerType: 'fading-circle'
                });
                const res =  await judgeSearch({type,condition})
                console.log(res,"done")
                this.data = res.data
                Indicator.close();
            },
            payStation(item){
                console.log(item.pay_station+"1")
                if(item.pay_station==1){
                    return "已支付"
                }else{
                    return "未支付"
                }
            },
            judgePayStation(item){
              if(item.pay_time==null){
                return "未支付"
              }else{
                return "已支付"
              }
            }

        },
    };
</script>

<style lang="scss" scoped>
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
        font-size: 15px;
    }
    .condition{
        width: 100%;
        white-space: nowrap;
        overflow-y: scroll;
        overflow-y: hidden;
        &::-webkit-scrollbar{
            display: none;
        }
        overflow: scroll;

    }
    .line{
        width: 100%;
        white-space: nowrap;
        overflow-y: scroll;
        overflow-y: hidden;
        &::-webkit-scrollbar{
            display: none;
        }
        overflow: scroll;
    }
    .title{
        width: 100%;
        text-align: left;
        span{
            color: #FFF;
            text-align: center;
            margin-right: 5px;
            margin-bottom: 5px;
            display: inline-block;
            width: 150px;
            height: 30px;
            line-height: 30px;
            background: #2c9a58;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    .item{
        span{
            color: #000;
            background: #dedede;
        }
    }

</style>

